import { ProductionStatusEnum } from "../../enums";
import { IProductionDisplayState, IProductionPollState } from "../../models";
import { safeNumber } from "../numbers.helpers";

export const getProductionDisplayStateFromPollState = (
  state: IProductionPollState | undefined,
): IProductionDisplayState => {
  const baseDisplayState: Partial<IProductionDisplayState> = {
    ...(state?.data || {}),
    productionId: state?.productionId,
    totalBookingCount: safeNumber(state?.data?.totalBookingCount),
    bookingsAlreadyInProduceCount: safeNumber(
      state?.data?.bookingsAlreadyInProduceCount,
    ),
    joinedRideCount: safeNumber(state?.data?.joinedRideCount),
    joinedBookingCount: safeNumber(state?.data?.joinedBookingCount),
    producedRideCount: safeNumber(state?.data?.producedRideCount),
    producedBookingCount: safeNumber(state?.data?.producedBookingCount),
    failedToSaveProducedRidesCount: safeNumber(
      state?.data?.failedToSaveProducedRidesCount,
    ),
    rideTooShortBookingCount: safeNumber(state?.data?.rideTooShortBookingCount),
    notFoundRidesToJoinBookingCount: safeNumber(
      state?.data?.notFoundRidesToJoinBookingCount,
    ),
    notFoundRidesToJoinBookingIds: state?.data?.notFoundRidesToJoinBookingIds,
    failedToSaveJoinedRideCount: safeNumber(
      state?.data?.failedToSaveJoinedRideCount,
    ),
    failedToSaveJoinedBookingCount: safeNumber(
      state?.data?.failedToSaveJoinedBookingCount,
    ),
    joinedSentRideSupplierCanceledCount: safeNumber(
      state?.data?.joinedSentRideSupplierCanceledCount,
    ),
    joinedSentRideSupplierUpdatedCount: safeNumber(
      state?.data?.joinedSentRideSupplierUpdatedCount,
    ),
    courseJoinedSentRideSupplierCanceledCount: safeNumber(
      state?.data?.courseJoinedSentRideSupplierCanceledCount,
    ),
    courseJoinedSentRideSupplierUpdatedCount: safeNumber(
      state?.data?.courseJoinedSentRideSupplierUpdatedCount,
    ),
    coursesSkippedOnNoPassengersCount: safeNumber(
      state?.data?.coursesSkippedOnNoPassengersCount,
    ),
    coursesSkippedOnNoPassengers: state?.data?.coursesSkippedOnNoPassengers,
    coursesAlreadyExistCount: safeNumber(state?.data?.coursesAlreadyExistCount),
    coursesAlreadyExist: state?.data?.coursesAlreadyExist,
    producedCoursesCount: safeNumber(state?.data?.producedCoursesCount),
    producedCourses: state?.data?.producedCourses,
    notSavedCoursesCount: safeNumber(state?.data?.notSavedCoursesCount),
    notSavedCourses: state?.data?.notSavedCourses,
    skippedPassengerBookingCount: safeNumber(
      state?.data?.skippedPassengerBookingCount,
    ),
    skippedPassengerBookingIds: state?.data?.skippedPassengerBookingIds,
  };

  switch (state?.status) {
    case ProductionStatusEnum.FAILED:
      return {
        ...baseDisplayState,
        isLoading: false,
        isFinished: true,
        loadPercentage: 0,
        error: state.data?.error ?? baseDisplayState.error,
        productionId: state.productionId,
      };

    case ProductionStatusEnum.FINISHED:
      return {
        ...baseDisplayState,
        isLoading: false,
        isFinished: true,
        loadPercentage: 100,
        error: null,
        productionId: state.productionId,
      };

    case ProductionStatusEnum.ABORTED:
      return {
        ...baseDisplayState,
        isLoading: false,
        isFinished: true,
        isAborted: true,
        loadPercentage: 0,
        error: null,
        productionId: state.productionId,
      };

    case ProductionStatusEnum.STARTED:
      return {
        ...baseDisplayState,
        isLoading: true,
        isFinished: false,
        isAborted: false,
        loadPercentage: 1,
        error: null,
      };

    case ProductionStatusEnum.IN_PROGRESS: {
      const { current, totalBookingCount } = state.data;
      const totalBookingsCountChecked = safeNumber(totalBookingCount);
      const percent =
        current && totalBookingsCountChecked
          ? Number((current / totalBookingsCountChecked) * 100)
          : 0;

      return {
        ...baseDisplayState,
        isLoading: true,
        isFinished: false,
        loadPercentage: safeNumber(percent),
        error: null,
      };
    }

    default:
      return {
        ...baseDisplayState,
        isLoading: false,
        isFinished: false,
        loadPercentage: 0,
        error: null,
      };
  }
};
